import { PendingFileUpload } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

export const pendingFileUploadsSelector =
  (projectId: string) =>
  (state: ReduxState): PendingFileUpload[] | undefined =>
    state.projects.pendingFileUploadsByProjectId[projectId];
